import React, { useState, useEffect } from 'react';
import { Button, Box, useDisclosure, VStack, Heading, Flex } from '@chakra-ui/react';
import JobCard from './JobCard';
import JobPostingDrawer from './JobPostingDrawer';
import { fetchAllJobs, postJob } from '../../utils/api';

const JobsPage = () => {
  const [jobs, setJobs] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    const fetchJobs = async () => {
      const jobsData = await fetchAllJobs();
      setJobs(jobsData);
    };

    fetchJobs();
  }, []);

  const handlePostJob = async (jobDetails) => {
    const newJob = await postJob(jobDetails);
    setJobs((prevJobs) => [...prevJobs, newJob]);
    onClose();
  };

  return (
    <Box>
      <Flex direction="column" align="center" mt="70px" mx={4}>
        <VStack align="start" spacing={5} w="full" maxW="80%">
          <Heading 
            as="h1" 
            size="xl" 
            className="page-title" 
            style={{
              background: 'linear-gradient(45deg, #E27A47 45%, #4BB19D 55%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Jobs
          </Heading>
          <Button onClick={onOpen}>
            Post a job
          </Button>
        </VStack>
        {jobs.map((job) => (
          <JobCard key={job.id} job={job} />
        ))}
      </Flex>
      <JobPostingDrawer isOpen={isOpen} onClose={onClose} onPostJob={handlePostJob} />
    </Box>
  );
};

export default JobsPage;
